import $ from 'jquery';

$(function() {
    
    // hide menu modal on desktop
    var width = $(window).width();
    function mediaSize() {
        if (width > '992') {
            $('#menuModal').modal('hide');
            $(".modal-backdrop").remove();
        }
    }
    window.addEventListener("resize", mediaSize, false);

    // Menu backdrop
    $('[id*="menu-item"].menu-item-has-children').on('show.bs.dropdown', function () {
        if (window.matchMedia("(min-width: 992px)").matches) {
            $(".modal-backdrop").remove();
            $('<div class="modal-backdrop fade"></div>').appendTo(document.body);
            setTimeout(function(){  $(".modal-backdrop.fade").addClass('show'); }, 100);
        }
    })
    $('.dropdown-search').on('show.bs.dropdown', function () {
        if (window.matchMedia("(max-width: 991px)").matches) {
            $('#menuModal').modal('hide');
        }
        $(".modal-backdrop").remove();
        $('<div class="modal-backdrop fade"></div>').appendTo(document.body);
        setTimeout(function(){  $(".modal-backdrop.fade").addClass('show'); }, 100);
    })
    
    $('[id*="menu-item"].menu-item-has-children, .dropdown-search').on('hide.bs.dropdown', function () {
        if (window.matchMedia("(min-width: 992px)").matches) {
            $(".modal-backdrop").remove();
        }
    })
    $('.dropdown-search').on('hide.bs.dropdown', function () {
        $(".modal-backdrop").remove();
    })

});
